import { Fragment, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button } from '@leroy-merlin-br/backyard-react-ui'

import { Field } from 'lmcv/components/Field'
import * as relationship from 'lmcv/services/relationship'

import WizardStep from '../components/WizardStep'
import * as Ilustrations from '../components/Ilustrations'
import * as S from '../styled'

const InviteCustomer = ({
  step,
  errors,
  register,
  inviteUrl,
  customerData,
  closeDrawer
}) => {
  const [isOnClipboard, setIsOnClipboard] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSentToEmail, setIsSentToEmail] = useState(false)

  const { email } = customerData

  const onSendInvite = async () => {
    setIsLoading(true)

    const payload = {
      relationshipId: inviteUrl.split('/convite/')[1],
      guestEmail: email
    }

    const handleSuccess = () => {
      setIsSentToEmail(true)
      setTimeout(() => {
        window.location.reload()
        closeDrawer()
      }, 2000)
    }

    const handleError = err => {
      console.error(err)
    }

    await relationship
      .sendInvite(payload)
      .then(handleSuccess)
      .catch(handleError)
      .finally(() => setIsLoading(false))
  }

  const onCopyToClip = () => {
    setIsOnClipboard(true)
    setTimeout(() => setIsOnClipboard(false), 1000)
  }

  const renderInvitationSent = () => (
    <Fragment>
      <S.StepTitle as="h3" size="mega">
        Convite enviado!
      </S.StepTitle>
      <S.StepSubTitle>
        Seu convite foi enviado para <strong>{email}</strong>
      </S.StepSubTitle>
    </Fragment>
  )

  const renderSendInvitation = () => (
    <Fragment>
      <S.StepTitle as="h3" size="mega">
        Convide seu cliente para participar do projeto
      </S.StepTitle>
      <S.FieldGrid>
        <Field
          type="email"
          name="email"
          title="Enviar por e-mail"
          placeholder="Ex: joaodasilva@gmail.com"
          reference={register({ required: true })}
          errors={errors?.email}
          errorMessage="Campo e-mail precisa ser preenchido."
        />
        <Button
          type="button"
          size="kilo"
          isLoading={isLoading}
          onClick={onSendInvite}
        >
          Enviar
        </Button>
        <Field
          title="Compartilhar link"
          disabled="disabled"
          defaultValue={inviteUrl}
          noPlaceholder
        />
        <CopyToClipboard text={inviteUrl} onCopy={onCopyToClip}>
          <Button type="button" size="kilo">
            {isOnClipboard ? 'Copiado!' : 'Copiar'}
          </Button>
        </CopyToClipboard>
      </S.FieldGrid>
    </Fragment>
  )

  return (
    <WizardStep step={3} currentStep={step}>
      <Ilustrations.Envelope />
      {isSentToEmail ? renderInvitationSent() : renderSendInvitation()}
    </WizardStep>
  )
}

export default InviteCustomer
